"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitForTx = exports.hasSucceeded = exports.hasFailed = exports.isPending = exports.getTransactionOrigin = exports.getTransactionHref = exports.buildTransactionWithReceiptPayload = exports.buildTransactionPayload = exports.getTransactionHashFromAction = exports.getTransactionFromAction = exports.isTransactionAction = exports.buildActionRef = exports.TRANSACTION_ACTION_FLAG = void 0;
const chain_id_1 = require("@dcl/schemas/dist/dapps/chain-id");
const effects_1 = require("redux-saga/effects");
const types_1 = require("./types");
const actions_1 = require("./actions");
// Special flag used to determine transaction hashes to be monitored
exports.TRANSACTION_ACTION_FLAG = '_watch_tx';
function buildActionRef(transaction) {
    const { actionType, withReceipt, payload } = transaction;
    const buildFunction = withReceipt
        ? buildTransactionWithReceiptPayload
        : buildTransactionPayload;
    return {
        type: actionType,
        payload: buildFunction(transaction.chainId, transaction.hash, payload)
    };
}
exports.buildActionRef = buildActionRef;
function isTransactionAction(action) {
    return !!getTransactionFromAction(action);
}
exports.isTransactionAction = isTransactionAction;
function getTransactionFromAction(action) {
    return action.payload && action.payload[exports.TRANSACTION_ACTION_FLAG];
}
exports.getTransactionFromAction = getTransactionFromAction;
function getTransactionHashFromAction(action) {
    return getTransactionFromAction(action).hash;
}
exports.getTransactionHashFromAction = getTransactionHashFromAction;
function buildTransactionPayload(chainId, hash, payload = {}) {
    return {
        [exports.TRANSACTION_ACTION_FLAG]: {
            chainId,
            hash,
            payload
        }
    };
}
exports.buildTransactionPayload = buildTransactionPayload;
function buildTransactionWithReceiptPayload(chainId, hash, payload = {}) {
    const txPayload = buildTransactionPayload(chainId, hash, payload);
    txPayload[exports.TRANSACTION_ACTION_FLAG].withReceipt = true;
    return txPayload;
}
exports.buildTransactionWithReceiptPayload = buildTransactionWithReceiptPayload;
function getTransactionHref({ txHash, address, blockNumber }, network) {
    const pathname = address
        ? `/address/${address}`
        : blockNumber
            ? `/block/${blockNumber}`
            : `/tx/${txHash}`;
    return `${getTransactionOrigin(network)}${pathname}`;
}
exports.getTransactionHref = getTransactionHref;
function getTransactionOrigin(chainId = chain_id_1.ChainId.ETHEREUM_MAINNET) {
    switch (chainId) {
        case chain_id_1.ChainId.ETHEREUM_ROPSTEN:
            return 'https://ropsten.etherscan.io';
        case chain_id_1.ChainId.ETHEREUM_RINKEBY:
            return 'https://rinkeby.etherscan.io';
        case chain_id_1.ChainId.ETHEREUM_GOERLI:
            return 'https://goerli.etherscan.io';
        case chain_id_1.ChainId.MATIC_MAINNET:
            return 'https://explorer-mainnet.maticvigil.com';
        case chain_id_1.ChainId.MATIC_MUMBAI:
            return 'https://explorer-mumbai.maticvigil.com';
        default:
            return 'https://etherscan.io';
    }
}
exports.getTransactionOrigin = getTransactionOrigin;
function isPending(status) {
    return !types_1.FINISHED_STATUS.includes(status);
}
exports.isPending = isPending;
function hasFailed(status) {
    return types_1.FAILED_STATUS.includes(status);
}
exports.hasFailed = hasFailed;
function hasSucceeded(status) {
    return types_1.SUCCESS_STATUS.includes(status);
}
exports.hasSucceeded = hasSucceeded;
/**
 * Waits for a transaction to be completed.
 *
 * @param txHash - The hash of the transaction to wait for.
 */
function* waitForTx(txHash) {
    while (true) {
        const { success, failure } = yield effects_1.race({
            success: effects_1.take(actions_1.FETCH_TRANSACTION_SUCCESS),
            failure: effects_1.take(actions_1.FETCH_TRANSACTION_FAILURE)
        });
        if ((success === null || success === void 0 ? void 0 : success.payload.transaction.hash) === txHash) {
            break;
        }
        else if ((failure === null || failure === void 0 ? void 0 : failure.payload.transaction.hash) === txHash) {
            throw new Error(`The transaction ${txHash} failed to be mined.`);
        }
    }
}
exports.waitForTx = waitForTx;
//# sourceMappingURL=utils.js.map